import React from "react";

function Overlay({ closeModalHandler }) {
  return <div className={"overlay"} onClick={closeModalHandler}></div>;
}

export default Overlay;
